<div class="content wz-table-step">

  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">{{ mapName }} <span class="gold">states</span></h2>
  </div>

  <p class="wz-lead">Add details to steer the AI for each state. <strong>Everything here is optional</strong>: leave a row blank and the AI decides.</p>

  <div class="scroll-container flex-grow-1 px-3">
    <!-- Chaos Level Row -->
    <div class="chaos-level-row mb-4 d-flex align-items-center justify-content-center gap-3">
      <label for="stateChaosLevel" class="chaos-label fw-bold">Chaos level</label>
      <div class="select-wrapper custom-select-width">
        <ng-select class="wt-select" id="stateChaosLevel" [(ngModel)]="stateChaosLevel" [items]="chaosLevels"
          placeholder="Choose…" [clearable]="false" appendTo="body">
          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
        </ng-select>
      </div>
    </div>

    <!-- Table Container -->
    <div class="table-container mx-auto">
      <table class="states-table w-100">
        <thead>
          <tr>
            <th class="col-name text-left">Name</th>
            <th class="col-corruption text-left">Corruption</th>
            <th class="col-domestic text-left">Domestic Policy</th>
            <th class="col-foreign text-left">Foreign Policy</th>
            <th class="col-notes text-left">Notes</th>
          </tr>
        </thead>
        <tbody>
          @for (state of statesList; track state; let i = $index) {
            <tr>
              <!-- Name -->
              <td class="col-name">
                <span class="state-name-text">{{ state.name }}</span>
              </td>
              <!-- Corruption -->
              <td class="col-corruption">
                <div class="select-wrapper">
                  <ng-select class="wt-select" [(ngModel)]="state.corruption" [items]="corruptions"
                    placeholder="Choose…" [clearable]="false" appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                  </ng-select>
                </div>
              </td>
              <!-- Domestic Policy -->
              <td class="col-domestic">
                <div class="select-wrapper">
                  <ng-select class="wt-select" [(ngModel)]="state.domesticPolicy" [items]="domesticPolicies"
                    placeholder="Choose…" [clearable]="false" appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                  </ng-select>
                </div>
              </td>
              <!-- Foreign Policy -->
              <td class="col-foreign">
                <div class="select-wrapper">
                  <ng-select class="wt-select" [(ngModel)]="state.foreignPolicy" [items]="foreignPolicies"
                    placeholder="Choose…" [clearable]="false" appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                  </ng-select>
                </div>
              </td>
              <!-- Notes -->
              <td class="col-notes">
                <input type="text" class="form-input" [(ngModel)]="state.notes"
                  placeholder="Notes for {{ state.name }} (optional)" />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

    </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>

  </div>
